<template>
  <information-page
    pageHeaderText="Map Background Information"
    capabilityUrl="/map-backgrounds"
    documentationUrl="https://developers.afrigis.co.za/portfolio/mapping/"
    capabilityVideoUrl="https://www.youtube.com/embed/UEpGLasR2oE"
  >
    <template #bannerImage>
      <b-img alt="Banner Image" fluid :src="bannerImage" />
    </template>
    <template #whatIsSection>
      <p class="h2">What is a map background?</p>
      <p>
        It is the canvas used to display data on. Your map background gives
        geographical context and enables you to position yourself in terms of
        scale and location. For optimal results, your map background needs to be
        selected carefully depending on the type of data being showcased and the
        question you want answered.
      </p>
      <p>
        Satellite imagery is powerful when observing growing
        cityscapes, land development and our impact as humans on the landscape
        over time. There is also the quality of imagery one needs to keep in
        mind. How time-sensitive is the data you want to interrogate? Satellite
        imagery alone might give you the wrong answer, that is why it is
        important to back up the visuals of the map with accurate and verified
        data like roads, addresses and points of interest or landmarks.
      </p>
      <p>
        Vector maps are useful if you need a quick view of man-made features and
        don’t need to interrogate the landscape. Its main purpose is to
        summarise the landscape and assist the user to orientate themselves and
        discover locations. Vector maps can be customised, and the level of
        detail you want to show on the map is entirely up to you. Ultimately,
        the question you need answered will determine the type of map background
        you would need to showcase your data on.
      </p>
    </template>
    <template #explainedSection>
      <p class="h3">Map Background Explained</p>
      <p>The video below explains more on how Map Background works.</p>
    </template>
    <template #possibleUses>
      <p class="h3">Possible uses:</p>
      <ul>
        <li>Showcase data on a vector or satellite map background.</li>
        <li>Examine the landscape on the map using satellite imagery.</li>
        <li>View changes over time in the landscape with satellite imagery.</li>
        <li>Confirm property boundaries.</li>
        <li>
          Accurately place data on a map by using satellite imagery to confirm
          locations.
        </li>
        <li>
          Available via API to integrate into your own solutions.
        </li>
      </ul>
    </template>
    <template #imageSection1>
      <b-img alt="Image Section 1" fluid :src="image1" />
    </template>
    <template #imageSection2>
      <b-img alt="Image Section 2" fluid :src="image2" />
    </template>
    <template #makesADifferenceSection>
      <p class="h2">WHERE AfriGIS makes a difference with Map Background:</p>
      <ul>
        <li>
          Major telecom companies rely on map backgrounds to indicate where
          network coverage areas are.
        </li>
        <li>
          Data teams working with address validation and verification make use
          of both vector and satellite map backgrounds to ensure fast work
          processes and correct data.
        </li>
        <li>
          FMCGs make use of map backgrounds to visually indicate where their
          brands operate.
        </li>
        <li>
          The retail industry uses a map background and data to add insights to
          their store footprint.
        </li>
      </ul>
    </template>
  </information-page>
</template>

<script>
import InformationPage from '@/components/InformationPage.vue';
import {
  BImg,
} from 'bootstrap-vue';

const bannerImage = require('@/assets/images/mapBackground/AG_MapBG_Hero.webp');
const image1 = require('@/assets/images/mapBackground/AG_MapBG.webp');
const image2 = require('@/assets/images/mapBackground/AG_MapBG_Line.webp');

export default {
  components: {
    BImg,
    InformationPage,
  },
  computed: {
    bannerImage: () => bannerImage,
    image1: () => image1,
    image2: () => image2,
  },
};
</script>

<style scoped>
</style>
